import React from 'react';

interface ConfidentialAgreementContextType {
  confidentialAgreementButton: JSX.Element;
}

export const ConfidentialAgreementContext = React.createContext<ConfidentialAgreementContextType>(
  {} as ConfidentialAgreementContextType,
);
